module.exports = __webpack_public_path__ + "img/usa-ovarian-cancer-female.72eb3ac2.png";